module.exports = __webpack_public_path__ + "332a947c67670ed3c742f2ac9d622262.pdf";